/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - possibly replace by built-in function custom events
*/

const Events = (function Events() {
    //private var
    var _listeners = {},
        /**
         * Add an event listener of type and the listener (function)
         * it's recommended to used a variable function since you can deleted it later.
         * @param type
         * @param listener
         */
        addListener = function (type, listener) {
            if (typeof _listeners[type] == 'undefined') {
                _listeners[type] = [];
            }
            _listeners[type].push(listener);
        },
        /**
         * Trigger a call for all the listener(functions) for a given type
         * you may pass any argument that you would like
         * The ONLY constraint is that the last argument === type of event
         * example fire(arg1, arg2, {*}, TYPE);
         * the data is attached to the event - event.data
         * @param event
         */
        fire = function () {
            var args = Array.prototype.slice.call(arguments),
                event = args.pop();

            if (typeof event == 'string') {
                event = { type: event };
            }

            //if (!event.target) {
            //    event.target = this;
            //}

            if (!event.type) {
                throw new Error("Event object missing 'type' property.");
            }
            //attach data
            event.data = args;

            if (_listeners[event.type] instanceof Array) {
                var listeners = _listeners[event.type];
                for (var i = 0, len = listeners.length; i < len; i++) {
                    listeners[i].call(this, event);
                }
            }
        },
        /**
         * Delete a type of listener and all of its listener functions as well
         * @param type
         */
        removeListenerType = function (type) {
            if (_listeners[type]) {
                delete _listeners[type];
            }
        },
        /**
         * remove a listener within a type. Only works if it was not an anonymous function
         * @param type
         * @param listener
         */
        removeListener = function (type, listener) {
            if (_listeners[type] instanceof Array) {
                var listeners = _listeners[type];
                for (var i = 0, len = listeners.length; i < len; i++) {
                    if (listeners[i] === listener) {
                        listeners.splice(i, 1);
                        break;
                    }
                }
            }
        };

    /**
     * INTERFACE
     */
    return {
        addListener: addListener,
        fire: fire,
        removeListener: removeListener,
        removeListenerType: removeListenerType,
    };
})();

export { Events as default };
